import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";

const isActive = (pathname: string, href: string) => {
  const target = href.split("?")[0];
  if (target === "/") return pathname === "/";
  return pathname.startsWith(target);
};

export default function SiteHeader() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [today, setToday] = useState("");

  useEffect(() => {
    const d = new Date();
    const week = ["日", "一", "二", "三", "四", "五", "六"][d.getDay()];
    setToday(
      `${d.getFullYear()} 年 ${d.getMonth() + 1} 月 ${d.getDate()} 日 · 星期${week}`,
    );
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="hidden bg-foreground-900 md:block">
        <div className="mx-auto flex max-w-[1360px] items-center justify-between px-6 py-1.5 font-label text-xs text-background-300">
          <span className="flex items-center gap-2">
            <span className="block h-1.5 w-1.5 rounded-full bg-accent-500" />
            {siteInfo.tagline}
          </span>
          <span className="tabular-nums">{today}</span>
        </div>
      </div>

      <div className="border-b border-foreground-800 bg-foreground-950">
        <div className="mx-auto flex max-w-[1360px] items-center justify-between gap-6 px-4 py-3 md:px-6 md:py-4">
          <Link to="/" className="flex shrink-0 items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
              黑
            </span>
            <span className="font-heading text-lg font-bold tracking-tight text-background-50 md:text-xl">
              {siteInfo.name}
            </span>
          </Link>

          <nav aria-label="主导航" className="hidden items-center gap-1 md:flex">
            {navLinks.map((link) => {
              const active = isActive(pathname, link.href);
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`whitespace-nowrap rounded-md px-3 py-2 font-label text-sm transition-colors ${
                    active
                      ? "bg-foreground-800 text-background-50"
                      : "text-background-300 hover:bg-foreground-800 hover:text-background-50"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/news"
              aria-label="搜索追踪"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-foreground-700 text-background-300 transition-colors hover:border-primary-500 hover:text-background-50"
            >
              <i className="ri-search-line text-base" />
            </Link>
            <Link
              to="/about#contact"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-block"
            >
              投递线索
            </Link>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label="打开菜单"
              aria-expanded={open}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-foreground-700 text-background-300 md:hidden"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>

        {open ? (
          <nav
            aria-label="移动端导航"
            className="border-t border-foreground-800 bg-foreground-950 px-4 py-3 md:hidden"
          >
            <ul className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="block whitespace-nowrap rounded-md px-3 py-2.5 font-label text-sm text-background-200 transition-colors hover:bg-foreground-800 hover:text-background-50"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about#contact"
                  className="mt-1 block whitespace-nowrap rounded-md bg-primary-500 px-3 py-2.5 text-center font-label text-sm font-medium text-background-50"
                >
                  投递线索
                </Link>
              </li>
            </ul>
          </nav>
        ) : null}
      </div>
    </header>
  );
}